import { Component, computed, inject, Input, output, Signal } from '@angular/core';
import { BusStopItemForm } from '../../forms/bus-stop.item.form';
import {
  BusStopAppEntityBusStopWrite,
  BusStopDictionaryAppEntityDictionaryBusStopDictionary,
  BusStopDictionaryService
} from '../../../../../../../../openapi';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { FilterDataPipe } from '../../../../../../../../pipes/filter-data.pipe';

@Component({
  selector: 'app-bus-stop-item-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    FilterDataPipe
  ],
  templateUrl: './bus-stop-item-form.component.html'
})
export class BusStopItemFormComponent {

  public submit = output<BusStopAppEntityBusStopWrite>();

  public cancel = output<void>();

  private busStopService: BusStopDictionaryService = inject(BusStopDictionaryService);

  public listOfStops: Signal<BusStopDictionaryAppEntityDictionaryBusStopDictionary[] | undefined> = toSignal(this.busStopService.getBusStopDictionaryCollectionBusStopDictionaryCollection({
    pagination: false
  }));

  public roadNumbers: Signal<Set<string>> = computed(() => new Set(this.listOfStops()?.map(v => v.roadNumber || '')?.sort() || []));

  @Input()
  public form: BusStopItemForm | undefined;

  @Input()
  public edit = false;

  @Input()
  public showCancel = true;

  public roadNumberChange(v: string): void {
    this.form?.roadSide.setValue('');
    this.form?.stopNumber.setValue('');
    this.form?.stopName.setValue('');
    this.form?.location.setValue('');
  }

  public roadSideChange(v: string): void {
    this.form?.stopNumber.setValue('');
    this.form?.stopName.setValue('');
    this.form?.location.setValue('');
  }

  public stopNumberChange(v: string): void {
    const roadNumber = this.form?.roadNumber.value;
    const roadSide = this.form?.roadSide.value;
    const stopNumber = this.form?.stopNumber.value;

    const stopItem = this.listOfStops()
      ?.filter(stop => roadNumber === stop.roadNumber)
      ?.filter(stop => roadSide === stop.roadSide)
      ?.filter(stop => stopNumber === stop.stopNumber)
      ?.at(0);

    this.form?.stopName.setValue(stopItem?.stopName || '');
    this.form?.location.setValue(stopItem?.chainage ||  0);
  }

  public onSubmit(): void {
    if (this.form?.valid) {
      this.submit.emit(this.form.values);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.cancel.emit();
    this.form?.reset();
  }

}
